import React, { useState } from 'react';
import './Art.css';
import ProductCard from './ProductCard';

function Art() {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const categories = [
    { id: 1, name: 'Abstract African Art', emoji: '🎨' },
    { id: 2, name: 'Tribal Patterns', emoji: '🌍' },
    { id: 3, name: 'Contemporary Afro', emoji: '✨' },
    { id: 4, name: 'Heritage Portraits', emoji: '👑' },
    { id: 5, name: 'Geometric Designs', emoji: '🔷' },
    { id: 6, name: 'Cultural Symbols', emoji: '🪶' },
    { id: 7, name: 'Landscape Art', emoji: '🌅' },
    { id: 8, name: 'Digital Afro Art', emoji: '💎' },
    { id: 9, name: 'Street Art Style', emoji: '🎭' },
    { id: 10, name: 'Mixed Media Art', emoji: '🌟' },
  ];

  const getProductsForCategory = (categoryId) => {
    const categoryName = categories.find(c => c.id === categoryId)?.name;
    const styles = [
      'Print',
      'Canvas',
      'Digital',
      'Framed',
      'Poster',
      'Tapestry',
      'Illustration',
      'Ensemble',
      'Limited Edition',
      'Masterpiece',
    ];

    return Array.from({ length: 20 }, (_, index) => {
      const style = styles[index % styles.length];
      const price = [35, 65, 28, 89, 22, 55, 42, 125, 150, 199][index % 10];
      return {
        id: categoryId * 100 + index + 1,
        name: `${categoryName} ${style} - Style ${index + 1}`,
        price,
        image: '🎨',
        description: `${style} ${categoryName} artwork`,
      };
    });
  };

  if (selectedCategory) {
    const products = getProductsForCategory(selectedCategory);
    const categoryName = categories.find(c => c.id === selectedCategory)?.name;

    return (
      <div className="art-section">
        <div className="section-header">
          <button className="back-btn" onClick={() => setSelectedCategory(null)}>
            ← Back to Categories
          </button>
          <h2>{categoryName}</h2>
          <p>Celebrate African Art & Culture</p>
        </div>
        <div className="products-grid">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="art-section">
      <div className="section-header">
        <h2>🎨 African Art Collection</h2>
        <p>Explore 10 Stunning Art Categories</p>
      </div>
      <div className="categories-grid">
        {categories.map((category) => (
          <div
            key={category.id}
            className="category-card"
            onClick={() => setSelectedCategory(category.id)}
          >
            <div className="category-emoji">{category.emoji}</div>
            <h3>{category.name}</h3>
            <p>10+ Unique Designs</p>
            <button className="view-btn">View Collection</button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Art;
